module.exports = __webpack_public_path__ + "04d914819968943eaa8db0ec7d5aeee5.svg";